import { useTranslation } from "react-i18next";

import {
	Box,
	InputLabel
} from "@launchmetrics/lm-ui";

// import { Period } from "./fields/Period";
import { FeedClipping } from "./fields/FeedClipping";
import { Language } from "./fields/common/Language";
import { Currency } from "./fields/common/Currency";
import { GroupLocation } from "./fields/common/GroupLocation";

export const PowerPoint: React.FC = () => {
	const { t } = useTranslation();

	return (
		<>
			<Box className='side-panel-content-entry'>
				<Box className='side-panel-inline'>
					{/* TODO GIS-4672 This Period component is creating an infinite loop, check why and fix */}
					{/* <Period /> */}
				</Box>
			</Box>
			<Box className='side-panel-content-entry'>
				<Box><InputLabel>{t('reports.groups')}</InputLabel></Box>
				<GroupLocation />
			</Box>

			<Box className='side-panel-content-entry'>
				<Box><InputLabel>{t('reports.settings')}</InputLabel></Box>
				<Language />
				<Currency />
			</Box>

			<Box className='side-panel-content-entry'>
				<FeedClipping />
			</Box>
		</>
	);
};
